export const SHOW_PRODUCT_SEARCH = "SHOW_PRODUCT_SEARCH"
export const HIDE_PRODUCT_SEARCH = "HIDE_PRODUCT_SEARCH"
export const SHOW_MENU_SIDEBAR = "SHOW_MENU_SIDEBAR"
export const HIDE_MENU_SIDEBAR = "HIDE_MENU_SIDEBAR"
export const SHOW_CATEGORIES_SIDEBAR = "SHOW_CATEGORIES_SIDEBAR"
export const HIDE_CATEGORIES_SIDEBAR = "HIDE_CATEGORIES_SIDEBAR"
export const SET_SELECTED_HOME_PAGE = "SET_SELECTED_HOME_PAGE"